import { lazy } from 'react'

export const WeightLossDate = lazy(() => import('./v1/WeightLossDate'))
export const WeightLossDateV2 = lazy(() => import('./v2/WeightLossDateV2'))
